import { defineComponent, inject, createBlock, openBlock, unref, mergeProps, withCtx, renderSlot } from "vue";
import { cn } from "../../../../lib/utils.js";
import { ORIENTATION_INJECTION_KEY, TYPE_INJECTION_KEY } from "./injectionKeys.js";
import { tabsListVariants } from "./variants.js";
import { _ as _sfc_main$1 } from "../../../../node_modules/.pnpm/reka-ui@2.3.1_typescript@5.8.3_vue@3.5.16_typescript@5.8.3_/node_modules/reka-ui/dist/Tabs/TabsList.js";
import { reactiveOmit } from "../../../../node_modules/.pnpm/@vueuse_shared@13.3.0_vue@3.5.16_typescript@5.8.3_/node_modules/@vueuse/shared/index.js";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "TabsList",
  props: {
    class: {},
    loop: { type: Boolean },
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  setup(__props) {
    const props = __props, delegatedProps = reactiveOmit(props, ["class"]), orientation = inject(ORIENTATION_INJECTION_KEY), type = inject(TYPE_INJECTION_KEY);
    return (_ctx, _cache) => (openBlock(), createBlock(unref(_sfc_main$1), mergeProps({
      class: unref(cn)(unref(tabsListVariants)({ orientation: unref(orientation), type: unref(type) }), props.class),
      "data-slot": "tabs-list"
    }, unref(delegatedProps)), {
      default: withCtx(() => [
        renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    }, 16, ["class"]));
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=TabsList.js.map
